import { FormControl, MenuItem, Select, Typography } from "@material-ui/core";
import clsx from "clsx";
import { LynxInput } from "components/LynxInput/LynxInput";
import { ReactComponent as FilterDownArrow } from "icons/FilterDownArrow.svg";
import React from "react";
import { LynxSelectProps } from "./LynxSelectProps";
import { lynxSelectStyles } from "./LynxSelectStyles";

export default function LynxSelect({
    label,
    isMultiple,
    value,
    options,
    onChange,
    disabled,
    margin,
    className,
}: LynxSelectProps) {
    const classes = lynxSelectStyles({ margin });
    return (
        <>
            <FormControl className={clsx(classes.formControl, className)}>
                {label && <Typography className={classes.label}>{label}</Typography>}
                <Select
                    disabled={disabled}
                    multiple={isMultiple}
                    IconComponent={FilterDownArrow}
                    displayEmpty
                    value={value}
                    onChange={onChange}
                    input={<LynxInput />}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                        },
                        transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                        },
                        getContentAnchorEl: null,
                        style: {
                            marginTop: 1,
                            maxHeight: 300,
                        },
                    }}
                >
                    {options.map((option, index) => (
                        <MenuItem
                            className={classes.menuItem}
                            key={option.itemValue}
                            value={option.itemValue}
                            classes={{ selected: classes.selected }}
                            disabled={option.isDisabled}
                        >
                            {option.itemName}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
}
